import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components';
import { useUser } from '@/app/providers';
import { hasFeature } from '@/domain/authentication';
import { DocumentExplorer } from './components';
import { DocumentPermissionProvider } from './context/DocumentPermissionContext';
import type { DocumentPermission } from './types';

export function DocumentsPage({ folderId }: { folderId?: string }) {
  const navigate = useNavigate();
  const { user } = useUser();

  const hasAdmin = user ? hasFeature(user, 'documents.admin') : false;
  const hasRead = user ? hasFeature(user, 'documents.read') : false;

  useEffect(() => {
    if (user && !hasAdmin && !hasRead) navigate({ to: '/profile' });
  }, [user, hasAdmin, hasRead, navigate]);

  if (!user || (!hasAdmin && !hasRead)) return null;

  const permission: DocumentPermission = hasAdmin ? 'admin' : 'read';

  return (
    <DocumentPermissionProvider permission={permission}>
      <ErrorBoundary>
        <DocumentExplorer folderId={folderId} />
      </ErrorBoundary>
    </DocumentPermissionProvider>
  );
}
